import { DirectionsCarOutlined } from '@mui/icons-material';
import { Fab, Stack, Tooltip, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import './TargetSelectorOpenerButton.css';

export default function TargetSelectorOpenerButton({
  setOnClicked,
  targetSelected,
  isVehicleOrRouteSelected,
  title,
}: {
  setOnClicked: (clicked: boolean) => void;
  targetSelected?: boolean;
  isVehicleOrRouteSelected: boolean;
  title: string;
}) {
  const { t } = useTranslation();
  const [highlight, setHighlight] = useState(false);
  const [openTooltipAndPulse, setopenTooltipAndPulse] = useState<boolean>(true);

  useEffect(() => {
    if (isVehicleOrRouteSelected) {
      setopenTooltipAndPulse(false);
    } else {
      setopenTooltipAndPulse(true);
    }
  }, [isVehicleOrRouteSelected]);

  useEffect(() => {
    let glowIntervalId: NodeJS.Timeout;
    let inactivityTimeoutId: NodeJS.Timeout;

    function startGlowing() {
      if (isVehicleOrRouteSelected) return;
      setHighlight(true);
      setTimeout(() => setHighlight(false), 1000);
    }

    function startInactivityTimer() {
      clearTimeout(inactivityTimeoutId);
      clearInterval(glowIntervalId);

      inactivityTimeoutId = setTimeout(() => {
        startGlowing();
        glowIntervalId = setInterval(startGlowing, 5000);
      }, 5000);
    }

    window.addEventListener('touchstart', startInactivityTimer);

    startInactivityTimer();

    return () => {
      clearTimeout(inactivityTimeoutId);
      clearInterval(glowIntervalId);
      window.removeEventListener('touchstart', startInactivityTimer);
    };
  }, [targetSelected, isVehicleOrRouteSelected]);

  const tooltipText = (
    <Stack>
      <Typography variant="body2" sx={{ fontWeight: 600 }}>
        {title}
      </Typography>
      <Typography variant="caption">{t('tracking.chooseVehicle')}</Typography>
    </Stack>
  );

  return (
    <Tooltip
      title={tooltipText}
      placement="left"
      open={openTooltipAndPulse}
      arrow
      slotProps={{
        popper: {
          sx: { zIndex: '3 !important' },
        },
        tooltip: {
          sx: { backgroundColor: 'primary.main' },
          // @ts-expect-error this works but gives error :(
          'data-qa-element-id': 'target-selector-tooltip',
        },
        arrow: {
          sx: { color: 'primary.main' },
        },
      }}
    >
      <Fab
        onClick={() => {
          setOnClicked(true);
        }}
        className={`target-selector-opener-button${highlight ? '-glow' : ''}`}
        size="medium"
        data-qa-element-id="target-selector-button"
      >
        <DirectionsCarOutlined sx={{ position: 'relative', top: -2 }} fontSize="large" />
      </Fab>
    </Tooltip>
  );
}
